import React from 'react';
import ReactDom from 'react-dom';

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {deepBind} from 'base-contentmodel';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import {LayoutComponent, SingleLayoutComponent, ColumnLayoutComponent, ColumnsWithTitleLayoutComponent, RowLayoutComponent, TableLayoutComponent} from './component';

export class LayoutContentModel extends BaseContentModel {

    static get _slots() {
        return {
            includeWrapperDivs: true,
            css: "",
        };
    }

    static get _defaults() {
        return {
            includeWrapperDivs: true,
            css: "",
        };
    }

    Component = LayoutComponent;

    @observable
    /* @slot */ includeWrapperDivs = true;

    @observable
    /* @slot */ css = "";
}
export class SingleLayoutContentModel extends LayoutContentModel {

    static get _slots() {
        return Object.assign({}, LayoutContentModel._slots, {
            child: BaseContentModel
        });
    }

    static get _defaults() {
        return Object.assign({}, LayoutContentModel._defaults, {
            child: null
        });
    }

    Component = SingleLayoutComponent;

    @observable
    /* @slot */ child = null;
}
export class ColumnLayoutContentModel extends LayoutContentModel {

    static get _slots() {
        return Object.assign({}, LayoutContentModel._slots, {
            children: [BaseContentModel]
        });
    }

    static get _defaults() {
        return Object.assign({}, LayoutContentModel._defaults, {
            children: null
        });
    }

    Component = ColumnLayoutComponent;

    @observable.shallow
    /* @slot */ children = [];
}
export class ColumnsWithTitleLayoutContentModel extends LayoutContentModel {

    static get _slots() {
        return Object.assign({}, LayoutContentModel._slots, {
            title: "",
            children: [BaseContentModel]
        });
    }

    static get _defaults() {
        return Object.assign({}, LayoutContentModel._defaults, {
            title: "",
            children: null
        });
    }

    Component = ColumnsWithTitleLayoutComponent;

    @observable
    /* @slot */ title = "";

    @observable.shallow
    /* @slot */ children = [];
}
export class RowLayoutContentModel extends LayoutContentModel {

    static get _slots() {
        return Object.assign({}, LayoutContentModel._slots, {
            children: [BaseContentModel]
        });
    }

    static get _defaults() {
        return Object.assign({}, LayoutContentModel._defaults, {
            children: null
        });
    }

    Component = RowLayoutComponent;

    @observable.shallow
    /* @slot */ children = [];
}
export class TableLayoutContentModel extends LayoutContentModel {

    static get _slots() {
        return Object.assign({}, LayoutContentModel._slots, {
            rows: 0,
            columns: 0,
            children: [BaseContentModel]
        });
    }

    static get _defaults() {
        return Object.assign({}, LayoutContentModel._defaults, {
            rows: 0,
            columns: 0,
            children: null
        });
    }

    Component = TableLayoutComponent;

    @observable
    /* @slot */ rows = 0;

    @observable
    /* @slot */ columns = 0;

    @observable.shallow
    /* @slot */ children = [];
}



export default LayoutContentModel;



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/layouts/contentmodel.js